export const ROUTES = {
    dashboard: "/",
    employee: "/employee",
    configuration: "/configuration",
    report: "/report",
    attendanceReport: "/report/attendance",
    productivityReport: "/report/productivity",
    performanceReport: "/report/performance",
    overtimeReport: "/report/overtime",
    payroll: "/payroll",
    payrollDeductions: "/payroll/deductions",
    walletManagement: "/payroll/wallet",
    employeeBankDetails: "/payroll/bank-details",
    batchManagement: "/payroll/batch",
    hrApprovals: "/payroll/hr-approvals",
    accountantApprovals: "/payroll/accountant-approvals",
    payrollSettings: "/payroll/settings",
    settlementManagement: "/payroll/settlement",
    payrollAllowances: "/payroll/allowances",
    paymentSuccess: "/payment-success",
    entries: "/entries",
    settings: "/settings",
    // Admin Overtime Management Routes
    adminOvertime: "/admin/overtime",
    adminOvertimeSettings: "/admin/overtime/settings",
    adminOvertimeRequests: "/admin/overtime/requests",
    adminOvertimeAssignment: "/admin/overtime/assignment",
    adminOvertimeAnalytics: "/admin/overtime/analytics",
    adminOvertimeReports: "/admin/overtime/reports"
}

export const filterByArr = [
    {
      label: "Employee ID",
      value: "employee_id"
    },
    {
      label: "Phone Number",
      value: "phone_number"
    },
    {
      label: "Email",
      value: "email"
    },
    {
      label: "Last Name",
      value: "last_name"
    },
    {
      label: "First Name",
      value: "first_name"
    },
  ]
